import script from "./CompanyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyView.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyView.vue?vue&type=style&index=0&id=22a1aeda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a1aeda"]])

export default __exports__